import React from 'react';
import { Text } from 'react-native';

const OperatolPanelInformationMaterialScreen = () => {
  return <Text>OperatolPanelInformationMaterialScreen</Text>;
};

export default OperatolPanelInformationMaterialScreen;
